// extracted by mini-css-extract-plugin
module.exports = {"container":"CompanyFormNominate_container__3HeSK"};